import React from 'react'
import { Input, Button, AlertError, FormDashboardInputPassword } from '../../../components'
import { Link, useHistory } from 'react-router-dom'
import auth from '../../../utils/auth'
import { formUpdater, useViewport } from '../../../utils'
import loginService from '../service'
import { useDispatch, useSelector } from 'react-redux'
import { setToken } from '../../../features/system/slice'
import { fetchAccount, setPopupContent } from '../../../features/account/slice'

const Form = ({className, onClose, noRedirect, embed}) => {
  const dispatch = useDispatch()
  const [form, setForm] = React.useState({})
  const [errorMessage, setErrorMessage] = React.useState(null)
  const [requesting, setRequesting] = React.useState(false)
  const history = useHistory()
  const { setTokenToLocalStorage } = auth()
  const { isMobile } = useViewport()
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  const updateForm = (e) => formUpdater(e, form, setForm)

  const validateForm = () => {
    if(!form.email || form.email === ''){
      return false
    }
    if(!form.password || form.password === ''){
      return false
    }

    return true
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    console.log(form)

    if(requesting === false && validateForm()){
      // Set loading state
      setRequesting(true)
      if(errorMessage !== null) setErrorMessage(null)

      loginService.getTokenFromAPI(form)
        .then((res) => {
          console.log(res);

          const token = res.token

          if(token){
            // Token received.
            setTokenToLocalStorage(token)
            setRequesting(false)
            dispatch(setToken(token))

            if(noRedirect && onClose){
              dispatch(fetchAccount())
              onClose()
            } else {
              history.push('/')
            }
          } else {
            console.error('Token not received from API')
          }
        })
        .catch((err) => {
          setErrorMessage(err)
          setRequesting(false)
        })
    } else {
      setErrorMessage('Form is not valid.')
    }
  }

  return (
    <form className={`lg:w-11/12 ${className}`} onSubmit={handleSubmit}>
      <div className="mb-3">
        <Input
          placeholder={translation.AUTH.email[language.name]}
          className="w-full"
          type="email"
          name="email"
          onChange={updateForm}
          required
        />
      </div>
      <div className="mb-5 lg:mb-8">
        <FormDashboardInputPassword
          placeholder={translation.AUTH.password[language.name]}
          className="w-full lg:p-4"
          name="password"
          onChange={updateForm}
          required
        />
      </div>
      <div className="mb-5 lg:mb-8 text-sm flex justify-end text-gray-444">
        {/*
          "Remember Me" feature is currently hidden, based on https://stackoverflow.com/questions/549/the-definitive-guide-to-form-based-website-authentication#477579 Part II.
        */}
        {/* <div className="flex items-center">
          <input type="checkbox" id="remember" className="mr-2 block"/>
          <label htmlFor="remember" className="cursor-pointer">
            {translation.AUTH.remember_me[language.name]}
          </label>
        </div> */}
        <div>
          {
            embed ? <span onClick={() => dispatch(setPopupContent('forgot'))} className="underline">
              {translation.AUTH.forgot_password[language.name]}?
            </span> :
            <Link to="/forgot-password" className="underline">
              {translation.AUTH.forgot_password[language.name]}?
            </Link>
          }
        </div>
      </div>

      <Button
        thin={isMobile}
        disabled={requesting}
        isLoading={requesting}
      >
        <span>
          {translation.AUTH.login[language.name]}
        </span>
      </Button>

      {
        errorMessage &&
        <AlertError
          message={errorMessage}
          onClose={() => setErrorMessage(null)}
        />
      }
    </form>
  )
}

export { Form }
